var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.647,
    height: 33.782,
    viewBox: "0 0 23.647 33.782",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "LocationSupport",
    d: "M19.324,3A11.815,11.815,0,0,0,7.5,14.824c0,8.868,11.824,21.958,11.824,21.958S31.147,23.692,31.147,14.824A11.815,11.815,0,0,0,19.324,3Zm0,16.046a4.223,4.223,0,1,1,4.223-4.223A4.224,4.224,0,0,1,19.324,19.046Z",
    transform: "translate(-7.5 -3)",
    fill: "#5e2b97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationSupport);
export default __webpack_public_path__ + "static/media/LocationSupport.8a58e6417bde62e6c18eba7e2e4b54a2.svg";
export { ForwardRef as ReactComponent };